export default __webpack_public_path__ + "static/media/carbon_close_black.efd20eb4.svg";